"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCookie = void 0;
const getCookie = (key) => {
    const regex = new RegExp(key + '=([^;]*)');
    const matches = document.cookie.match(regex);
    return matches ? decodeURIComponent(matches[1]) : null;
};
exports.getCookie = getCookie;
